export default __webpack_public_path__ + "static/media/soehne-mono-halbfett.68b705ce.ttf";